<template>
  <md-button class="md-icon-button" @click="action()" title="Move to Inbox">
    <md-icon class="text-gray">move_to_inbox</md-icon>
  </md-button>
</template>
<script>
import StatusUpdateMixin from "@/mixins/StatusUpdateMixin";

export default {
  name: "ActionInbox",
  props: ["item", "collection"],
  mixins: [StatusUpdateMixin],
  data: () => ({
    status: "I"
  })
};
</script>